import { Col } from "react-bootstrap";
import SmartField from "../../../../rhf/smartfield";
import * as yup from 'yup';

export const GetReinstituteValidationSchema = (formValues) => {
    const base = {
        reason: yup.string().required("*Required"),
        facility: yup.string().required("*Required")
    }

    return base;
    
}

const ReinstituteFields = ({register,errors,lookupdata}) => {
    return(
        <>
            <Col xs={12}>
                <strong className="d-flex justify-content-center">Reinstitute Information</strong>
            </Col>
            <Col xs={12}>
                <SmartField
                    label='Reason for Reinstitutionalization'
                    name='reason'
                    type='select'
                    options={lookupdata.reinstitutetypes}
                    style={{width: '100%'}}
                    register={register}
                    errors={errors}
                />
            </Col>
            <Col xs={12}>
                <SmartField
                    label='Reinstitute Facility'
                    name='facility'
                    type='select'
                    options={lookupdata.facilitytypes}
                    style={{width: '100%'}}
                    register={register}
                    errors={errors}
                />
            </Col>
        </>
    )
}

export default ReinstituteFields;